const endpoints = {
  getPaginatedReports: '/v1/exports/csv',
  getPreSignedUrl: '/v1/exports/csv/:id',
};

export default endpoints;
